// Iter 211 — 🎡 Réservation des excursions depuis l'Espace Adhérent.
// Iter 224 — Réservations NOMINATIVES : on coche chaque voyageur, le tarif
// (plein / réduit / forfait) est calculé automatiquement d'après sa date de naissance.
import React, { useState, useEffect } from 'react';
import { Lightbox } from './espace/BlocsFiche';
import { precacherPhotos } from '../utils/espaceMemoire';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
// Iter 638 (Kamel) — excursion gratuite : on gère la présence, aucun montant affiché.
const estGratuite = (e) => !!e.gratuite || (!(e.tarif_plein > 0) && !(e.tarif_reduit > 0) && !(e.option_prix > 0));
// Iter 640 — « Départ en » : car par défaut, sinon à pied / taxi / bateau / train / minibus / autre.
export const DEPART_MODES = { car: '🚌 Car', pied: '🚶 À pied', taxi: '🚕 Taxi', bateau: '⛴️ Bateau', train: '🚆 Train / métro', minibus: '🚐 Minibus', autre: '✍️ Autre' };
export const departLabel = (e) => (e.depart_mode === 'autre' ? `✍️ ${e.depart_autre || 'Autre'}` : (DEPART_MODES[e.depart_mode] || DEPART_MODES.car));
export const departIcone = (e) => departLabel(e).split(' ')[0];
// Iter 641 — « départ 9h15 en car · rendez-vous devant l'hôtel »
export const modePhrase = (e) => (e.depart_mode === 'pied' ? 'à pied' : e.depart_mode === 'autre' ? `— ${e.depart_autre || 'autre'}` : `en ${departLabel(e).replace(/^\S+\s/, '').toLowerCase()}`);
export const rdvTexte = (e) => e.heure_depart ? `${departIcone(e)} Départ ${e.heure_depart} ${modePhrase(e)}${e.lieu_rdv ? ` · 📍 rendez-vous ${e.lieu_rdv}` : ''}` : (e.lieu_rdv ? `📍 Rendez-vous ${e.lieu_rdv}` : '');
// Extras « simples » (carte de transport, bagage…) : pas une sortie → pas de car, pas d'horaires, pas de « places limitées ».
export const TYPE_ICONE = { excursion: '🚌', transport: '🎫', bagage: '🧳', restaurant: '🍽️', activite: '🎭', autre: '➕' };
export const typeIcone = (e, defaut = '🚌') => TYPE_ICONE[e.type] || defaut;
export const estExtraSimple = (e) => ['transport', 'bagage', 'autre'].includes(e.type || 'excursion');
// Iter 308 (Kamel) — 💶 Règlement des excursions UNIQUEMENT en espèces (car ou permanences).

// Iter 940 (Kamel) — libellé « quand » : vraie date / période (circuit) sinon le jour Espagne
const frDate = (d) => d ? new Date(d.slice(0, 10) + 'T12:00:00').toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' }) : '';
export const quandLabel = (e) => {
  if (e.date) return e.date_fin && e.date_fin !== e.date ? `Du ${frDate(e.date)} au ${frDate(e.date_fin)}` : frDate(e.date).replace(/^./, c => c.toUpperCase());
  return e.jour || '';
};

// Iter 304 — 🕘 excursion déjà passée cette semaine (semaine = samedi de départ).
const JOURS_OFFSET = { samedi: 0, dimanche: 1, lundi: 2, mardi: 3, mercredi: 4, jeudi: 5, vendredi: 6 };
const estPassee = (semaine, jour) => {
  const j = (jour || '').toLowerCase();
  const cle = Object.keys(JOURS_OFFSET).find(k => j.includes(k));
  if (!semaine || cle === undefined) return false;
  const d = new Date(`${semaine}T12:00:00`);
  if (Number.isNaN(d.getTime())) return false;
  d.setDate(d.getDate() + JOURS_OFFSET[cle]);
  d.setHours(23, 59, 59, 999);
  return d < new Date();
};

const tarifAuto = (item, v, reduitManuel = false) => {
  if ((item.reduit_mode || 'age') === 'manuel') return reduitManuel ? 'reduit' : 'plein';
  return (v.age != null && v.age < (item.age_reduit_max || 18)) ? 'reduit' : 'plein';
};

export const ExcursionsBlock = ({ token, regId, autoOpen = false }) => {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState('');

  const charger = async (manuel = false) => {
    try {
      const r = await fetch(`${API}/espace-adherent/${token}/excursions/${regId}`);
      if (!r.ok) {
        if (manuel) {
          const j = await r.json().catch(() => ({}));
          alert(j.detail || "Le programme d'excursions n'est pas disponible pour ce séjour. Contactez l'association si besoin.");
        }
        return;
      }
      const j = await r.json();
      setData(j);
      setOpen(true);
      precacherPhotos((j.excursions || []).map(e => e.lieu_rdv_photo));
    } catch (e) { if (manuel) alert('Erreur réseau — réessayez dans un instant.'); }
  };

  // Iter 222 (Kamel) — départ proche / séjour en cours : le bloc s'ouvre tout seul.
  useEffect(() => {
    if (autoOpen && !open && !data) charger();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoOpen]);

  const reserver = async (excId, passagers) => {
    setBusy(excId);
    try {
      const r = await fetch(`${API}/espace-adherent/${token}/excursions/${regId}`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ excursion_id: excId, passagers }),
      });
      const j = await r.json();
      if (!r.ok) { alert(j.detail || 'Erreur'); } else { await charger(); }
    } catch (e) { alert('Erreur réseau'); }
    setBusy('');
  };

  const souscrireForfait = async (forfaitId, passagers) => {
    setBusy(`forfait-${forfaitId}`);
    try {
      const r = await fetch(`${API}/espace-adherent/${token}/excursions/${regId}/forfait`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ forfait_id: forfaitId, passagers }),
      });
      const j = await r.json();
      if (!r.ok) { alert(j.detail || 'Erreur'); } else { await charger(); }
    } catch (e) { alert('Erreur réseau'); }
    setBusy('');
  };

  // Iter 313 — 🔔 liste d'attente quand une excursion est complète
  const listeAttente = async (excId, retirer) => {
    setBusy(`attente-${excId}`);
    try {
      const r = await fetch(`${API}/espace-adherent/${token}/excursions/${regId}/liste-attente`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ excursion_id: excId, retirer: !!retirer }),
      });
      const j = await r.json();
      if (!r.ok) { alert(j.detail || 'Erreur'); } else { await charger(); }
    } catch (e) { alert('Erreur réseau'); }
    setBusy('');
  };
  // Iter 940 — « Je ne souhaite rien réserver » (compte comme choix terminé ; sort des relances « aucun choix »)
  const rienReserver = async (oui) => {
    setBusy('rien');
    try {
      const r = await fetch(`${API}/espace-adherent/${token}/excursions/${regId}/rien-reserver`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ annuler: !oui }),
      });
      const j = await r.json();
      if (!r.ok) { alert(j.detail || 'Erreur'); } else { await charger(); }
    } catch (e) { alert('Erreur réseau'); }
    setBusy('');
  };

  if (!open) {
    return (
      <button onClick={() => charger(true)} data-testid={`fiche-excursions-btn-${regId}`}
        className="text-xs font-bold px-3 py-2 rounded-lg bg-amber-100 text-amber-900 hover:bg-amber-200 border border-amber-300">
        🎡 Extras & excursions de mon voyage — voir et réserver
      </button>
    );
  }
  if (!data) return null;

  const voyageurs = data.voyageurs || [];
  // Iter 320 — textes/règles éditables par programme (admin) ; vide = défaut Espagne
  const tx = data.program.textes || {};
  // Iter 458 (Kamel) — mode « voyage » : AUCUN texte par défaut (chaque voyage a ses propres infos)
  const defautsEspagne = (data.program.mode || 'semaines') !== 'voyage';
  // vi -> forfait_id qui le couvre (souscriptions de la fiche)
  const couverture = {};
  (data.mes_forfaits || []).forEach(s => (s.passagers || []).forEach(p => { if (p.vi != null) couverture[p.vi] = s.forfait_id; }));

  return (
    <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 space-y-3" data-testid={`fiche-excursions-${regId}`}>
      <div className="flex items-center justify-between">
        <p className="text-sm font-bold text-amber-900">🎡 {data.program.nom}{data.program.mode === 'voyage' ? '' : ` — semaine du ${data.semaine.split('-').reverse().join('/')}`}</p>
        <button onClick={() => setOpen(false)} className="text-xs text-amber-700 font-bold">✕ Fermer</button>
      </div>
      {(tx.reglement || defautsEspagne) && <div className="text-[11px] bg-white border border-amber-200 rounded-lg p-2.5 text-amber-900 leading-relaxed">
        {tx.reglement ? (
          <span className="whitespace-pre-line" data-testid="excursions-texte-reglement">{tx.reglement}</span>
        ) : (
          <>
            💶 <strong>Règlement uniquement en espèces.</strong>{' '}
            {data.avec_transport
              ? <>Préparez une enveloppe <strong>ouverte</strong> avec votre nom, le nom de l'excursion et la <strong>somme exacte</strong>, à remettre <strong>dans le car</strong>.</>
              : <>Le règlement s'effectue <strong>lors des permanences</strong> (dates communiquées par l'association).</>}
            {' '}Vous pouvez modifier ou annuler tant que le paiement n'a pas été remis — ensuite la réservation est définitive.
          </>
        )}
        {!tx.masquer_regles && (tx.regles || defautsEspagne) && (
        <span className="block mt-1.5 bg-red-50 border border-red-200 rounded p-1.5 text-red-800" data-testid="excursions-regles-paiement">
          {tx.regles ? (
            <span className="whitespace-pre-line">{tx.regles}</span>
          ) : (
            <>
              ⏰ <strong>Règles importantes :</strong> les <strong>forfaits</strong> se réservent <strong>jusqu'au dimanche soir 23h59</strong> (lendemain de l'arrivée) — au-delà, les excursions se réservent uniquement à l'unité.
              {' '}<strong>Toute réservation doit être réglée avant le dimanche soir 23h59</strong>, sinon elle est <strong>automatiquement annulée</strong> et la place remise à disposition.
              {' '}Une réservation faite en cours de semaine se règle <strong>le jour même</strong> — non réglée, elle est <strong>automatiquement supprimée le lendemain</strong>.
            </>
          )}
          {!tx.masquer_compte_a_rebours && !data.forfaits_clos && (() => {
            const dl = new Date(`${data.semaine}T23:59:59`);
            dl.setDate(dl.getDate() + 1);
            const ms = dl - new Date();
            if (ms <= 0) return null;
            const j = Math.floor(ms / 86400000), h = Math.floor((ms % 86400000) / 3600000);
            return (
              <span className="block mt-1 font-bold" data-testid="excursions-compte-a-rebours">
                ⏳ Clôture : dimanche {dl.toLocaleDateString('fr-FR')} à 23h59 — il reste {j > 0 ? `${j} jour${j > 1 ? 's' : ''} et ` : ''}{h} heure{h > 1 ? 's' : ''}.
              </span>
            );
          })()}
        </span>
        )}
        <span className="block mt-1">👥 Cochez simplement <strong>qui participe</strong> : le tarif de chacun (plein / réduit) est calculé automatiquement selon sa date de naissance.</span>
      </div>}
      {(data.program.forfaits || []).length > 0 && (
        <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-2.5 space-y-2" data-testid={`excursions-forfaits-${regId}`}>
          <p className="text-xs font-bold text-indigo-900">💳 Forfaits excursions — la formule maligne</p>
          {data.forfaits_clos && (
            <p className="text-[11px] font-bold text-red-700 bg-red-50 border border-red-200 rounded p-1.5" data-testid="excursions-forfaits-clos">
              🔒 Les forfaits sont clôturés pour cette semaine (réservables jusqu'au dimanche soir 23h59). Les excursions se réservent à l'unité ci-dessous.
            </p>
          )}
          {data.program.forfaits.map(f => (
            <ForfaitRow key={f.id} f={f} voyageurs={voyageurs} couverture={couverture}
              souscription={(data.mes_forfaits || []).find(s => s.forfait_id === f.id)}
              clos={!!data.forfaits_clos}
              busy={busy === `forfait-${f.id}`} onSave={souscrireForfait} />
          ))}
          <p className="text-[10px] text-indigo-700">Les personnes au forfait sont automatiquement à 0€ sur les excursions ci-dessous. Les excursions marquées HORS FORFAIT se règlent séparément.</p>
          <div className="bg-white border-2 border-red-300 rounded-lg p-2 text-[11px] text-red-800 leading-relaxed" data-testid="excursions-forfait-avertissement">
            {tx.forfait_avertissement ? (
              <span className="whitespace-pre-line">{tx.forfait_avertissement}</span>
            ) : (
              <>
                ⚠️ <strong>Important : la réservation de chaque excursion reste OBLIGATOIRE, même avec un forfait illimité.</strong>{' '}
                Le forfait est uniquement un <strong>mode de paiement promotionnel</strong> : il ne vous inscrit pas automatiquement à toutes les excursions.{' '}
                <strong>Seule la réservation fait foi</strong> — cochez qui participe sur chaque excursion ci-dessous, sinon votre place n'est pas garantie dans le car.
                <span className="block mt-1" data-testid="excursions-analogie-cinema">
                  🎬 <strong>Pour bien comprendre :</strong> le forfait illimité, c'est comme une <strong>carte cinéma illimitée</strong> — si vous ne réservez pas votre séance et que la salle est complète, vous ne verrez pas le film, même avec la carte. C'est exactement pareil ici.
                </span>
              </>
            )}
          </div>
        </div>
      )}
      {data.program.mode === 'voyage' && (
        <div className="bg-white border border-amber-200 rounded-lg p-2.5 text-[11px] text-amber-900" data-testid="excursions-voyage-entete">
          {data.program.butoir_utc && !data.program.clos && <p>⏳ <strong>Date limite pour vos choix : {new Date(data.program.butoir_utc).toLocaleString('fr-FR', { timeZone: 'Europe/Paris', weekday: 'long', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit' })} (heure de Paris)</strong>. Passé cette date, les demandes ne pourront plus être prises en compte, sauf accord exceptionnel de l'association.</p>}
          {data.program.clos && <p className="font-bold text-gray-700" data-testid="excursions-voyage-clos">🔒 Les choix sont clôturés pour ce voyage. Vos réservations restent consultables ci-dessous ; pour toute demande, contactez l'association.</p>}
          <p className="mt-1">💶 Règlement des extras <strong>en espèces</strong>.</p>
          {!data.program.clos && !data.excursions.some(e => e.ma_resa) && (
            <button onClick={() => rienReserver(!data.rien_reserver)} disabled={busy === 'rien'}
              className={`mt-2 text-[11px] font-bold px-3 py-1.5 rounded-lg ${data.rien_reserver ? 'bg-gray-200 text-gray-700' : 'bg-white border-2 border-[#1E3A5F] text-[#1E3A5F]'}`} data-testid="excursions-rien-reserver">
              {data.rien_reserver ? '✓ Vous avez indiqué ne rien réserver — changer d\'avis' : 'Je ne souhaite rien réserver'}
            </button>
          )}
        </div>
      )}
      {[...data.excursions].sort((a, b) => data.program.mode === 'voyage' ? ((a.date_reelle || '9999').localeCompare(b.date_reelle || '9999') || (a.heure_depart || '').localeCompare(b.heure_depart || '')) : 0).map(e => (
        <ExcursionRow key={e.id} e={e} voyageurs={voyageurs} couverture={couverture} onWaitlist={listeAttente}
          forfaits={data.program.forfaits || []} excursions={data.excursions}
          passee={data.program.mode === 'voyage' ? !!e.passee : estPassee(data.semaine, e.jour)}
          busy={busy === e.id} onSave={reserver} />
      ))}
      <MonProgramme data={data} token={token} regId={regId} />
      <RecapAdherent data={data} />
    </div>
  );
};

// Iter 643 (Kamel) — 📅 « Mon programme » : mes excursions réservées dans l'ordre (jour, heure), avec lieu, plan et liens.
const JOURS_ORDRE = ['samedi', 'dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi'];
const cleJour = (e) => {
  const j = (e.jour || '').toLowerCase();
  const idx = JOURS_ORDRE.findIndex(k => j.includes(k));
  const moment = /matin/.test(j) ? 0 : /midi|après/.test(j) ? 1 : /soir|nuit/.test(j) ? 2 : 1;
  const h = (e.heure_depart || '').match(/(\d{1,2})\s*[h:]\s*(\d{0,2})/);
  const minutes = h ? parseInt(h[1], 10) * 60 + parseInt(h[2] || '0', 10) : moment * 480 + 480;
  return (idx < 0 ? 99 : idx) * 10000 + minutes;
};
const MonProgramme = ({ data, token, regId }) => {
  const voyage = data.program.mode === 'voyage';
  const mes = data.excursions.filter(e => e.ma_resa && !e.annulee).sort((a, b) => voyage
    ? ((a.date_reelle || '9999').localeCompare(b.date_reelle || '9999') || (a.heure_depart || '').localeCompare(b.heure_depart || ''))
    : cleJour(a) - cleJour(b));
  const [zoom, setZoom] = useState(null);  // Iter 655 — photo du lieu de RDV agrandie
  if (mes.length < 1) return null;
  const passee = (e) => voyage ? !!e.passee : estPassee(data.semaine, e.jour);
  return (
    <div className="bg-white border-2 border-[#1E3A5F]/30 rounded-xl p-3" data-testid="mon-programme">
      <div className="flex flex-wrap items-center gap-2 mb-2">
        <p className="text-xs font-bold text-[#1E3A5F]">📅 Mon programme — {mes.length} sortie{mes.length > 1 ? 's' : ''} réservée{mes.length > 1 ? 's' : ''}, dans l'ordre</p>
        <a href={`${API}/espace-adherent/${token}/excursions/${regId}/programme.pdf`} target="_blank" rel="noopener noreferrer" className="ml-auto text-[11px] font-bold px-3 py-1.5 rounded-full bg-[#1E3A5F] text-white" data-testid="mon-programme-pdf">📄 Télécharger en PDF</a>
      </div>
      <ol className="relative border-l-2 border-[#1E3A5F]/20 ml-2 space-y-3">
        {mes.map(e => (
          <li key={e.id} className={`ml-4 ${passee(e) ? 'opacity-50' : ''}`} data-testid={`mon-programme-${e.id}`}>
            <span className="absolute -left-[7px] mt-1 w-3 h-3 rounded-full bg-[#1E3A5F]" />
            <p className="text-xs font-bold text-gray-900">{quandLabel(e) || (estExtraSimple(e) ? (e.periode || 'Pendant le voyage') : 'Jour à préciser')}{e.heure_depart ? ` · ${e.heure_depart}` : ''}{passee(e) ? ' · passée' : ''}</p>
            <p className="text-sm font-bold text-[#1E3A5F]">{typeIcone(e, '🎡')} {e.nom}</p>
            <div className="flex gap-2 items-start">
              <div className="min-w-0 flex-1">
                {!(estExtraSimple(e) && !e.heure_depart && !e.lieu_rdv) && <p className="text-[11px] text-gray-700">{rdvTexte(e) || `${departLabel(e)}`}{e.heure_retour ? ` · retour ${e.heure_retour}` : ''}</p>}
                <p className="text-[11px] text-gray-500">👥 {(e.ma_resa.passagers || []).map(p => p.nom).join(', ')}</p>
              </div>
              {e.lieu_rdv_photo && (
                <button type="button" onClick={() => setZoom({ url: e.lieu_rdv_photo, label: `📍 Rendez-vous${e.lieu_rdv ? ` ${e.lieu_rdv}` : ''} — ${e.nom}` })} className="shrink-0 text-center" data-testid={`mon-programme-rdv-photo-${e.id}`}>
                  <img src={e.lieu_rdv_photo} alt="Lieu de rendez-vous" loading="lazy" className="w-24 h-16 object-cover rounded-lg border-2 border-emerald-300" />
                  <span className="block text-[9px] text-emerald-800 font-bold">📍 le lieu de RDV</span>
                </button>
              )}
            </div>
            {(e.maps_url || (e.liens || []).length > 0) && (
              <div className="flex flex-wrap gap-1.5 mt-1">
                {e.maps_url && <a href={e.maps_url} target="_blank" rel="noopener noreferrer" className="text-[11px] font-bold px-2.5 py-1 rounded-full bg-emerald-50 text-emerald-800 border border-emerald-200" data-testid={`mon-programme-maps-${e.id}`}>📍 Plan du rendez-vous</a>}
                {(e.liens || []).map((l, k) => <a key={k} href={l.url} target="_blank" rel="noopener noreferrer" className="text-[11px] font-bold px-2.5 py-1 rounded-full bg-sky-50 text-sky-800 border border-sky-200">🔗 {l.label}</a>)}
              </div>
            )}
          </li>
        ))}
      </ol>
      {zoom && <Lightbox images={[zoom]} index={0} onIndex={() => {}} onClose={() => setZoom(null)} regId={regId} />}
    </div>
  );
};

const RecapAdherent = ({ data }) => {
  const tx = (data.program && data.program.textes) || {};
  // Iter 466 — fix page blanche : variable non définie dans ce composant (ReferenceError dès qu'il restait un montant à régler)
  const defautsEspagne = ((data.program && data.program.mode) || 'semaines') !== 'voyage';
  const lignes = [
    ...(data.mes_forfaits || []).map(s => ({
      label: `💳 ${s.forfait_nom} — ${(s.passagers || []).map(p => p.nom).join(', ')}`,
      total: s.total || 0, paye: !!s.paye,
    })),
    ...data.excursions.filter(e => e.ma_resa).map(e => ({
      label: `${typeIcone(e, '🎡')} ${e.nom} — ${(e.ma_resa.passagers || []).map(p => p.nom).join(', ')}`,
      horaire: [quandLabel(e) ? `📅 ${quandLabel(e)}` : '', e.periode ? `📆 ${e.periode}` : '', rdvTexte(e), e.heure_retour ? `retour ${e.heure_retour}` : ''].filter(Boolean).join(' · '),
      annulee: !!e.annulee,
      total: e.ma_resa.total || 0, paye: !!e.ma_resa.paye,
    })),
  ];
  if (lignes.length === 0) return null;
  const total = lignes.reduce((s, l) => s + l.total, 0);
  const remis = lignes.filter(l => l.paye).reduce((s, l) => s + l.total, 0);
  const aPreparer = total - remis;
  return (
    <div className="bg-[#1E3A5F] text-white rounded-xl p-3" data-testid="excursions-recap-adherent">
      <p className="text-xs font-bold mb-1.5">🧾 {defautsEspagne ? 'Mon récapitulatif de la semaine' : 'Mon récapitulatif — extras & excursions'}</p>
      <ul className="space-y-1 mb-2">
        {lignes.map((l, i) => (
          <li key={i} className="text-[11px]">
            <div className="flex justify-between gap-2">
              <span>{l.label}</span>
              <span className="font-bold whitespace-nowrap">{l.annulee ? <span className="text-red-300">❌ annulée</span> : <>{l.total.toFixed(0)}€ {l.paye ? '✅ remis' : ''}</>}</span>
            </div>
            {l.horaire && <div className="text-[10px] text-amber-200 font-semibold" data-testid="recap-adherent-horaire">{l.horaire}</div>}
          </li>
        ))}
      </ul>
      <div className="border-t border-white/20 pt-1.5 text-xs font-bold flex flex-wrap justify-between gap-2">
        <span>Total : {total.toFixed(0)}€{remis > 0 ? ` · déjà remis : ${remis.toFixed(0)}€` : ''}</span>
        <span className={aPreparer > 0 ? 'text-amber-300' : 'text-emerald-300'} data-testid="excursions-recap-apreparer">
          {aPreparer > 0 ? `💶 À régler : ${aPreparer.toFixed(0)}€` : '✅ Tout est réglé'}
        </span>
      </div>
      {aPreparer > 0 && !tx.reglement && defautsEspagne && (
        <p className="text-[10px] text-white/70 mt-1" data-testid="excursions-recap-especes-note">💶 Règlement <strong>uniquement en espèces</strong> : enveloppe ouverte (nom + excursion + somme exacte) à remettre dans le car, ou lors des permanences pour les personnes sans transport.</p>
      )}
      <p className="text-[10px] text-white/70 mt-1.5" data-testid="excursions-recap-actu-note">
        {tx.recap_note ? (
          <span className="whitespace-pre-line">{tx.recap_note}</span>
        ) : (
          <>📣 Horaires donnés à titre indicatif : suivez bien <strong>l'actualité de votre espace</strong> et vos notifications — en cas de changement d'horaire ou de programme, c'est ici que vous serez prévenus.</>
        )}
      </p>
    </div>
  );
};

const ForfaitRow = ({ f, voyageurs, couverture, souscription, busy, onSave, clos = false }) => {
  const [edit, setEdit] = useState(false);
  const [sel, setSel] = useState(() => new Set((souscription?.passagers || []).map(p => p.vi).filter(v => v != null)));
  const paye = !!souscription?.paye;
  const limite = f.limite > 0 ? `${f.limite} excursions au choix` : 'toutes les excursions';
  const prixDe = v => tarifAuto(f, v) === 'reduit' ? f.prix_reduit : f.prix_plein;
  const total = voyageurs.filter(v => sel.has(v.vi)).reduce((s, v) => s + prixDe(v), 0);
  const toggle = vi => setSel(s => { const n = new Set(s); n.has(vi) ? n.delete(vi) : n.add(vi); return n; });
  return (
    <div className="bg-white border border-indigo-100 rounded-lg p-2" data-testid={`forfait-row-${f.id}`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-[11px] text-indigo-900">
          <strong>{f.nom}</strong> — {f.prix_plein}€ / {f.prix_reduit}€ ({f.condition_reduit}) · {limite}
        </p>
        <div className="text-right">
          {souscription && !edit && (
            <span className="text-[11px] font-bold text-indigo-800" data-testid={`forfait-masouscription-${f.id}`}>
              ✅ {(souscription.passagers || []).map(p => `${p.nom} (${p.prix}€)`).join(' · ')} — {souscription.total}€
              {paye && <span className="block text-amber-700">💶 payé — définitif</span>}
            </span>
          )}
          {!paye && !edit && !clos && (
            <button onClick={() => { setSel(new Set((souscription?.passagers || []).map(p => p.vi).filter(v => v != null))); setEdit(true); }}
              data-testid={`forfait-edit-${f.id}`}
              className="ml-2 text-[11px] font-bold px-2.5 py-1 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700">
              {souscription ? 'Modifier' : 'Souscrire'}
            </button>
          )}
          {clos && !souscription && (
            <span className="text-[10px] font-bold text-red-600" data-testid={`forfait-clos-${f.id}`}>🔒 Clôturé</span>
          )}
        </div>
      </div>
      {edit && (
        <div className="mt-2 border-t border-indigo-100 pt-2 space-y-1.5 text-[11px]">
          {voyageurs.map(v => {
            const autreForfait = couverture[v.vi] && couverture[v.vi] !== f.id && !sel.has(v.vi);
            return (
              <label key={v.vi} className={`flex items-center gap-2 ${autreForfait ? 'opacity-40' : 'cursor-pointer'}`}>
                <input type="checkbox" checked={sel.has(v.vi)} disabled={autreForfait}
                  onChange={() => toggle(v.vi)} data-testid={`forfait-check-${f.id}-${v.vi}`} />
                <span className="font-semibold">{v.prenom} {v.nom}</span>
                <span className="text-gray-500">{v.age != null ? `${v.age} ans` : 'âge inconnu'}</span>
                <span className="font-bold text-indigo-800">{autreForfait ? 'déjà sur un autre forfait' : `${prixDe(v)}€${tarifAuto(f, v) === 'reduit' ? ' (réduit)' : ''}`}</span>
              </label>
            );
          })}
          <div className="flex items-center gap-2 pt-1">
            <span className="font-bold text-indigo-900">= {total.toFixed(0)}€</span>
            <button onClick={() => { onSave(f.id, [...sel].map(vi => ({ vi }))); setEdit(false); }} disabled={busy}
              data-testid={`forfait-save-${f.id}`}
              className="font-bold px-3 py-1.5 rounded-lg bg-emerald-600 text-white hover:bg-emerald-700 disabled:opacity-40">
              {busy ? '…' : sel.size > 0 ? 'Valider' : 'Annuler mon forfait'}
            </button>
            <button onClick={() => setEdit(false)} className="text-gray-500 font-bold">✕</button>
          </div>
        </div>
      )}
    </div>
  );
};

const ExcursionRow = ({ e, voyageurs, couverture, forfaits, excursions, busy, onSave, onWaitlist, passee }) => {
  const r = e.ma_resa;
  const [edit, setEdit] = useState(false);
  const [sel, setSel] = useState({}); // vi -> {reduit_manuel, option}
  const paye = !!r?.paye && (r?.total || 0) > 0; // 0 € (tout forfait) : reste modifiable
  const complet = e.restantes <= 0 && !r;

  const openEdit = () => {
    const init = {};
    (r?.passagers || []).forEach(p => { if (p.vi != null) init[p.vi] = { reduit_manuel: p.tarif === 'reduit' && (e.reduit_mode || 'age') === 'manuel', option: !!p.option }; });
    setSel(init);
    setEdit(true);
  };
  const toggle = vi => setSel(s => { const n = { ...s }; if (n[vi]) delete n[vi]; else n[vi] = { reduit_manuel: false, option: false }; return n; });
  const setFlag = (vi, k, val) => setSel(s => ({ ...s, [vi]: { ...s[vi], [k]: val } }));

  // Estimation du prix affiché (le serveur reste maître du calcul final)
  const usageForfait = vi => excursions.filter(x => x.id !== e.id && (x.ma_resa?.passagers || []).some(p => p.vi === vi && p.tarif === 'forfait')).length;
  // Iter 268 — option (bateau) tarifée par âge : 18+ / 11-17 / 5-10 / -5 ans
  const optionPrixDe = (e, v) => {
    if (e.option_prix_11_17 == null && e.option_prix_5_10 == null) return e.option_prix || 0;
    const a = v.age;
    if (a == null || a >= 18) return e.option_prix || 0;
    if (a >= 11) return e.option_prix_11_17 || 0;
    if (a >= 5) return e.option_prix_5_10 || 0;
    return e.option_prix_0_4 || 0;
  };
  const infoDe = v => {
    const st = sel[v.vi];
    if (!e.hors_forfait && couverture[v.vi] != null) {
      const f = forfaits.find(x => x.id === couverture[v.vi]);
      const lim = f?.limite || 0;
      if (lim <= 0 || usageForfait(v.vi) < lim) return { tarif: 'forfait', prix: st?.option ? optionPrixDe(e, v) : 0 };
    }
    const t = tarifAuto(e, v, st?.reduit_manuel);
    let prix = t === 'reduit' ? e.tarif_reduit : e.tarif_plein;
    if (st?.option) prix += optionPrixDe(e, v);
    return { tarif: t, prix };
  };
  const total = voyageurs.filter(v => sel[v.vi]).reduce((s, v) => s + infoDe(v).prix, 0);

  return (
    <div className={`bg-white border border-amber-100 rounded-lg p-2.5 ${passee ? 'opacity-50 grayscale' : ''}`} data-testid={`excursion-row-${e.id}`}>
      {e.annulee && (
        <div className="bg-red-50 border border-red-300 rounded-lg p-2 mb-2 text-[11px] font-bold text-red-700" data-testid={`excursion-annulee-${e.id}`}>
          ❌ Excursion annulée cette semaine{e.annulation_motif ? ` (${e.annulation_motif})` : ''} — rien à payer{paye ? ' : votre enveloppe vous sera remboursée par l\'association' : ''}. Suivez l'actualité de votre espace.
          {r && (r.passagers || []).length > 0 && (() => {
            // Iter 251 — 📅 report en 1 clic : mêmes personnes, autre excursion de la semaine.
            const alternatives = excursions.filter(x => x.id !== e.id && !x.annulee && !x.ma_resa
              && (x.restantes || 0) >= (r.passagers || []).length);
            if (!alternatives.length) return null;
            return (
              <div className="mt-1.5 font-normal">
                <p className="font-bold text-[#1E3A5F]">📅 Reporter {(r.passagers || []).map(p => p.nom).join(', ')} en 1 clic sur :</p>
                <div className="flex flex-wrap gap-1.5 mt-1">
                  {alternatives.map(x => (
                    <button key={x.id}
                      onClick={() => {
                        if (!window.confirm(`Réserver « ${x.jour} — ${x.nom} » pour ${(r.passagers || []).map(p => p.nom).join(', ')} ?\n\nLe tarif de chacun sera recalculé automatiquement.`)) return;
                        onSave(x.id, (r.passagers || []).filter(p => p.vi != null).map(p => ({ vi: p.vi })));
                      }}
                      className="text-[11px] font-bold px-2.5 py-1 bg-white border border-[#1E3A5F] text-[#1E3A5F] rounded-full hover:bg-[#1E3A5F] hover:text-white"
                      data-testid={`excursion-report-${e.id}-${x.id}`}>
                      {x.jour} — {x.nom}
                    </button>
                  ))}
                </div>
              </div>
            );
          })()}
        </div>
      )}
      {(e.photos || []).length > 0 && (
        <div className="flex gap-1.5 mb-2 overflow-x-auto">
          {e.photos.map((url, pi) => (
            <img key={pi} src={url} alt={e.nom} loading="lazy"
              className={`h-24 rounded-lg object-cover ${e.photos.length === 1 ? 'w-full' : 'min-w-[45%] flex-1'}`}
              data-testid={`excursion-photo-${e.id}-${pi}`} />
          ))}
        </div>
      )}
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="text-xs font-bold text-[#1E3A5F]">{typeIcone(e)} {quandLabel(e) ? `${quandLabel(e)} — ` : ''}{e.nom}
            {e.periode && <span className="ml-1.5 text-[9px] font-bold px-1.5 py-0.5 rounded bg-sky-100 text-sky-800 border border-sky-300 align-middle" data-testid={`excursion-periode-${e.id}`}>📆 {e.periode}</span>}
            {passee && <span className="ml-1.5 text-[9px] font-bold px-1.5 py-0.5 rounded bg-gray-200 text-gray-600 border border-gray-300 align-middle" data-testid={`excursion-passee-${e.id}`}>✔ DÉJÀ PASSÉE</span>}
            {e.hors_forfait && forfaits.length > 0 && <span className="ml-1.5 text-[9px] font-bold px-1.5 py-0.5 rounded bg-amber-100 text-amber-800 border border-amber-300 align-middle">HORS FORFAIT</span>}
          </p>
          {e.description && <p className="text-[11px] text-gray-500">{e.description}</p>}
          <p className="text-[11px] text-gray-600 mt-0.5">
            {rdvTexte(e) ? `${rdvTexte(e)}${e.heure_retour ? ` · Retour ${e.heure_retour}` : ''} · ` : ''}{estGratuite(e) ? <span className="font-bold text-emerald-700" data-testid={`excursion-gratuite-${e.id}`}>🎁 Incluse dans le prix de votre voyage — inscrivez-vous simplement pour réserver votre place</span> : <>💶 {e.tarif_plein}€</>}
            {!estGratuite(e) && e.tarif_reduit > 0 && <> / {e.tarif_reduit}€{e.condition_reduit ? ` (${e.condition_reduit})` : ''}</>}
            {e.option_nom && <> · Option : {e.option_nom} {e.option_prix_11_17 != null || e.option_prix_5_10 != null
              ? `${e.option_prix}€ (11-17 ans : ${e.option_prix_11_17 ?? e.option_prix}€ · 5-10 ans : ${e.option_prix_5_10 ?? e.option_prix}€ · moins de 5 ans : ${(e.option_prix_0_4 || 0) > 0 ? `${e.option_prix_0_4}€` : 'gratuit'})`
              : `${e.option_prix}€`}</>}
          </p>
          {e.note && <p className="text-[10px] text-amber-700">ℹ️ {e.note}</p>}
          {(e.maps_url || e.album_url || (e.liens || []).length > 0) && (
            <div className="flex flex-wrap gap-1.5 mt-1.5" data-testid={`excursion-liens-${e.id}`}>
              {e.maps_url && <a href={e.maps_url} target="_blank" rel="noopener noreferrer" className="text-[11px] font-bold px-2.5 py-1 rounded-full bg-emerald-50 text-emerald-800 border border-emerald-200" data-testid={`excursion-maps-${e.id}`}>📍 Plan du rendez-vous</a>}
              {(e.liens || []).map((l, k) => <a key={k} href={l.url} target="_blank" rel="noopener noreferrer" className="text-[11px] font-bold px-2.5 py-1 rounded-full bg-sky-50 text-sky-800 border border-sky-200" data-testid={`excursion-lien-${e.id}-${k}`}>🔗 {l.label}</a>)}
              {e.album_url && <a href={e.album_url} target="_blank" rel="noopener noreferrer" className="text-[11px] font-bold px-2.5 py-1 rounded-full bg-blue-50 text-blue-800 border border-blue-200" data-testid={`excursion-album-${e.id}`}>📸 Album photos</a>}
            </div>
          )}
          {/* Iter 256 (Kamel) — jamais le nombre de places restantes : phrase incitative,
              et « Complet » uniquement quand c'est complet. Valable pour toutes les excursions de tous les voyages. */}
          {!complet && !e.annulee && !r && !e.clos && !passee && !estExtraSimple(e) && (
            <p className="text-[10px] font-bold mt-0.5 text-red-600" data-testid={`excursion-places-limitees-${e.id}`}>
              ⏳ Places limitées — dépêchez-vous de réserver !
            </p>
          )}
        </div>
        <div className="text-right">
          {r && !edit && (
            <p className="text-[11px] font-bold text-emerald-800" data-testid={`excursion-maresa-${e.id}`}>
              ✅ {(r.passagers || []).map(p => `${p.nom}${p.tarif === 'forfait' ? ' (forfait)' : p.tarif === 'reduit' ? ' (réduit)' : ''}${p.option ? ' +option' : ''}`).join(' · ')} — {r.total}€
              {paye && <span className="block text-amber-700">💶 payé — définitif</span>}
            </p>
          )}
          {!paye && !edit && !complet && !e.annulee && !passee && !e.clos && (
            <button onClick={openEdit} data-testid={`excursion-edit-${e.id}`}
              className="mt-1 text-[11px] font-bold px-3 py-1.5 rounded-lg bg-[#1E3A5F] text-white hover:bg-[#2a4d7a]">
              {r ? 'Modifier / annuler' : 'Réserver'}
            </button>
          )}
          {e.clos && !edit && !e.annulee && (
            <p className="mt-1 text-[10px] font-bold text-gray-600 bg-gray-100 rounded px-2 py-1" data-testid={`excursion-clos-${e.id}`}>🔒 Réservations clôturées — contactez l'association pour toute demande exceptionnelle.</p>
          )}
          {!e.clos && e.butoir_utc && !paye && !e.annulee && !passee && (
            <p className="mt-1 text-[10px] text-sky-800" data-testid={`excursion-butoir-${e.id}`}>⏳ Jusqu'au {new Date(e.butoir_utc).toLocaleString('fr-FR', { timeZone: 'Europe/Paris', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}</p>
          )}
          {complet && !e.annulee && (
            <div>
              <p className="text-[11px] font-bold text-red-600">Complet</p>
              {!passee && (e.ma_liste_attente ? (
                <div className="mt-1 text-right" data-testid={`excursion-attente-pos-${e.id}`}>
                  <p className="text-[10px] font-bold text-amber-700">⏳ En liste d'attente (n°{e.ma_liste_attente})<br />On vous prévient dès qu'une place se libère !</p>
                  <button onClick={() => onWaitlist(e.id, true)} disabled={busy === `attente-${e.id}`}
                    className="text-[10px] text-gray-500 underline font-semibold"
                    data-testid={`excursion-attente-retirer-${e.id}`}>Me retirer de la liste</button>
                </div>
              ) : (
                <button onClick={() => onWaitlist(e.id, false)} disabled={busy === `attente-${e.id}`}
                  className="mt-1 text-[10px] font-bold px-2.5 py-1.5 rounded-lg bg-amber-500 text-white hover:bg-amber-600"
                  data-testid={`excursion-attente-btn-${e.id}`}>
                  🔔 Me prévenir si une place se libère
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
      {edit && (
        <div className="mt-2 border-t border-amber-100 pt-2 space-y-1.5 text-[11px]">
          <p className="text-[10px] font-bold text-gray-500">Qui participe ?</p>
          {voyageurs.map(v => {
            const checked = !!sel[v.vi];
            const info = checked ? infoDe(v) : null;
            return (
              <div key={v.vi} className="flex flex-wrap items-center gap-x-3 gap-y-1">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={checked} onChange={() => toggle(v.vi)}
                    data-testid={`excursion-check-${e.id}-${v.vi}`} />
                  <span className="font-semibold">{v.prenom} {v.nom}</span>
                  <span className="text-gray-500">{v.age != null ? `${v.age} ans` : 'âge inconnu'}</span>
                </label>
                {checked && (
                  <>
                    <span className={`font-bold ${info.tarif === 'forfait' ? 'text-indigo-700' : 'text-[#1E3A5F]'}`}
                      data-testid={`excursion-prix-${e.id}-${v.vi}`}>
                      {estGratuite(e) ? '🎁 incluse' : info.tarif === 'forfait' ? '💳 au forfait — 0€' : `${info.tarif === 'reduit' ? 'réduit ' : ''}${(info.tarif === 'reduit' ? e.tarif_reduit : e.tarif_plein)}€`}
                    </span>
                    {(e.reduit_mode || 'age') === 'manuel' && e.tarif_reduit > 0 && info.tarif !== 'forfait' && (
                      <label className="flex items-center gap-1 cursor-pointer text-amber-800">
                        <input type="checkbox" checked={!!sel[v.vi]?.reduit_manuel}
                          onChange={ev => setFlag(v.vi, 'reduit_manuel', ev.target.checked)}
                          data-testid={`excursion-reduit-${e.id}-${v.vi}`} />
                        {e.condition_reduit || 'tarif réduit'}
                      </label>
                    )}
                    {e.option_nom && (
                      <label className="flex items-center gap-1 cursor-pointer text-gray-700">
                        <input type="checkbox" checked={!!sel[v.vi]?.option}
                          onChange={ev => setFlag(v.vi, 'option', ev.target.checked)}
                          data-testid={`excursion-option-${e.id}-${v.vi}`} />
                        {e.option_nom} +{optionPrixDe(e, v) > 0 ? `${optionPrixDe(e, v)}€` : '0€ (gratuit)'}
                      </label>
                    )}
                  </>
                )}
              </div>
            );
          })}
          <div className="flex items-center gap-2 pt-1">
            <span className="font-bold text-[#1E3A5F]" data-testid={`excursion-total-${e.id}`}>{estGratuite(e) ? '🎁 Incluse dans le voyage — rien à régler' : `= ${total.toFixed(0)}€`}</span>
            <button onClick={() => {
              onSave(e.id, Object.entries(sel).map(([vi, st]) => ({ vi: +vi, reduit_manuel: !!st.reduit_manuel, option: !!st.option })));
              setEdit(false);
            }} disabled={busy}
              data-testid={`excursion-save-${e.id}`}
              className="font-bold px-3 py-1.5 rounded-lg bg-emerald-600 text-white hover:bg-emerald-700 disabled:opacity-40">
              {busy ? '…' : Object.keys(sel).length > 0 ? 'Valider' : 'Annuler ma réservation'}
            </button>
            <button onClick={() => setEdit(false)} className="text-gray-500 font-bold">✕</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExcursionsBlock;
